import { render, staticRenderFns } from "./InventoriesCompetencies.vue?vue&type=template&id=12fb2fb4&scoped=true&"
import script from "./InventoriesCompetencies.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCompetencies.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesCompetencies.vue?vue&type=style&index=0&id=12fb2fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb2fb4",
  null
  
)

export default component.exports